import { Box, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

// A yes/no field always reads as answered ("No" until ticked), so only a ticked one shows
// that the guest filled in the form.
const isAnswer = (field) => field.populated && (field.type !== 'boolean' || field.value === true);

/**
 * The participant's pre-check-in answers, read-only: the `precheckin` summary of
 * `GET /v2/edit/tour_user/{id}/` (backend apiv2/lib/pre_check_summary.py) -- every field of this
 * participant's form, standard and custom, with its label and display value. Nothing when
 * pre-check-in is off for the trip, the summary is missing, or nothing has been answered yet.
 */
const PrecheckinAnswers = ({ precheckin }) => {
    const fields = precheckin && precheckin.enabled && Array.isArray(precheckin.fields) ? precheckin.fields : [];
    if (!fields.some(isAnswer)) {
        return null;
    }
    return (
        <>
            <Typography style={{ textTransform: 'uppercase', marginLeft: '0.75rem', fontSize: '90%', marginTop: '2rem' }}>
                Pre-check-in answers
            </Typography>
            <Grid item xs={12}>
                <Box
                    component="dl"
                    data-testid="precheckin-answers"
                    sx={{ display: 'grid', gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 3fr)', columnGap: 2, rowGap: 0.75, m: 0 }}
                >
                    {fields.map((field) => (
                        <React.Fragment key={`${field.scope}:${field.id}`}>
                            <Typography component="dt" variant="body2" color="textSecondary" sx={{ overflowWrap: 'anywhere' }}>
                                {field.label}
                            </Typography>
                            <Typography
                                component="dd"
                                variant="body2"
                                color={field.populated ? 'textPrimary' : 'textSecondary'}
                                sx={{ m: 0, overflowWrap: 'anywhere', whiteSpace: 'pre-line' }}
                            >
                                {field.populated && field.display ? field.display : '—'}
                            </Typography>
                        </React.Fragment>
                    ))}
                </Box>
            </Grid>
        </>
    );
};

PrecheckinAnswers.propTypes = {
    precheckin: PropTypes.shape({
        enabled: PropTypes.bool,
        fields: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string,
            type: PropTypes.string,
            scope: PropTypes.string,
            populated: PropTypes.bool,
            display: PropTypes.string,
        })),
    }),
};

export default PrecheckinAnswers;
